// External dependencies
import classnames from 'classnames';
import React from 'react';

/**
 * Top-level admin sections.
 *
 * `prefix` is matched with `startsWith`, so every screen beneath a section
 * keeps its tab lit — e.g. all of `/admin/cms/*` highlights CMS.
 */
const sections = [{ path: '/admin/cms', label: 'CMS', prefix: '/admin/cms' }];

export default function AdminHeader() {
  const currentPath = window.location.pathname;

  return (
    <nav className="navbar navbar-default navbar-admin">
      <div className="container">
        <div className="navbar-header">
          <a
            className="navbar-brand"
            href="/admin"
            aria-label="Admin dash index"
          >
            <span>Admin Panel</span>
          </a>
        </div>
        <ul className="nav navbar-nav">
          {sections.map(section => (
            <li
              key={section.path}
              className={classnames({
                active: currentPath.startsWith(section.prefix),
              })}
            >
              <a href={section.path}>{section.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

AdminHeader.propTypes = {};
